/*
* @描述: 新建回款弹窗
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-14 14:47:55
*/
<template>
    <div>
        <el-dialog :before-close="handleDialogClose"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :modal-append-to-body="false"
                   :visible.sync="dialogVisible"
                   class="custom_form_dialog repayment_dialog"
                   title="新建回款"
                   width="620px">
            <div v-loading="loading">
                <el-form ref="repaymentForm"
                         :model="repaymentForm"
                         :rules="repaymentFormRules"
                         label-position="top"
                         size="small">
                    <el-row :gutter="24" style="flex-wrap: wrap" type="flex">
                        <el-col :span="12">
                            <el-form-item label="关联订单" prop="order_num">
                                <el-select v-model="repaymentForm.order_num"
                                           :disabled="source==='detail'"
                                           placeholder="请选择关联订单"
                                           @focus="handleOrderSelectFocus">
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="订单金额" prop="total_price">
                                <el-input v-model="orderDetailsData.total_price" disabled
                                          placeholder="自动带出">

                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="回款公司" prop="payment_company_name">
                                <el-select v-model="repaymentForm.payment_company_name"
                                           placeholder="请选择回款公司">
                                    <el-option v-for="item in relateCustomList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.name"
                                               @click.native="handleInvoiceCompanySelect(item)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="客户联系人" prop="contact_name">
                                <el-input v-model="orderDetailsData.contact_name" disabled
                                          placeholder="自动带出"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="销售" prop="salesperson_name">
                                <el-input v-model="orderDetailsData.salesperson_name" disabled
                                          placeholder="自动带出"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="回款日期" prop="payment_date">
                                <el-date-picker v-model="repaymentForm.payment_date"
                                                format="yyyy-MM-dd"
                                                placeholder="请选择回款日期"
                                                type="date"
                                                value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="回款方式" prop="payment_method">
                                <el-select v-model="repaymentForm.payment_method"
                                           placeholder="请选择发回款方式">
                                    <el-option :value="1" label="电汇"></el-option>
                                    <el-option :value="2" label="微信"></el-option>
                                    <el-option :value="3" label="支付宝"></el-option>
                                    <el-option :value="4" label="现金"></el-option>
                                    <el-option :value="5" label="银行承兑"></el-option>
                                    <el-option :value="6" label="商业承兑"></el-option>
                                    <el-option :value="7" label="支票"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="本次回款金额" prop="repay_amount">
                                <el-input v-model="repaymentForm.repay_amount"
                                          placeholder="请输入本次回款金额"
                                          @blur="handleInvoiceAmountInputBlur"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="备注" prop="remark">
                                <el-input v-model="repaymentForm.remark"
                                          :rows="4"
                                          placeholder="请输入备注信息"
                                          type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="附件" prop="attachments">
                                <div class="file_upload_wrap">
                                    <div v-if="repaymentForm.attachments.length===0" class="file_outer_wrap">
                                        <img alt=""
                                             src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                                             width="36">
                                        <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                        <p class="file_type_hint">支持Word、Excel、PDF等常见类型</p>
                                        <input class="upload_input"
                                               multiple
                                               type="file"
                                               @change="handleUploadFileChange($event)">
                                    </div>
                                    <ul v-else class="upload_file_list">
                                        <li v-for="(file,file_idx) in repaymentForm.attachments"
                                            class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <img alt="" class="file_img"
                                                     src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                    <p class="file_size" v-text="file.file_size"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览"
                                                            effect="dark"
                                                            placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="删除"
                                                            effect="dark"
                                                            placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                  @click="repaymentForm.attachments.splice(file_idx,1)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                        <li class="upload_file_btn_wrap">
                                            <i class="el-icon-plus"></i>
                                            <span>上传附件</span>
                                            <input class="upload_input"
                                                   multiple
                                                   type="file"
                                                   @change="handleUploadFileChange($event)">
                                        </li>
                                    </ul>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div slot="footer">
                <el-button size="small" @click="handleDialogClose">取消</el-button>
                <el-button size="small" type="primary" @click="handleClickConfirm">确定</el-button>
            </div>
        </el-dialog>
        <RelateOrderSelect v-if="selectOrderDialog"
                           :dialog-visible.sync="selectOrderDialog"
                           :projectId="projectId"
                           @success="handleClickOrderRow"/>
        <el-image ref="preview_img"
                  :preview-src-list="previewImgList"
                  :src="previewImgSrc"
                  style="display:none">
        </el-image>
    </div>
</template>
<script>
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import {formatFileSize, getNowDate} from "@/utils";
import { invoiceInfoByOrder, orderCreateRepay, orderDetail, ReceivableDetail} from "@/api";
import RelateOrderSelect from "../component/relate_order_selet_dialog";

export default {
    name: "RepaymentDialog",
    data() {
        return {
            repaymentForm: {
                order_num: "", // 订单编号
                payment_company_name: "",
                salesperson: 0, //销售人员UID (订单负责人UID)
                payment_date: "", //本次回款时间，格式：YYYY-MM-DD 必传的
                payment_method: '', //：1 电汇, 2 微信, 3 支付宝, 4 现金, 5 银行承兑, 6 商业承兑, 7 支票
                repay_amount: '', //本次回款金额
                remark: "", //备注
                attachments: []  //附件，JSON 数组
            },
            repaymentFormRules: {
                order_num: [{required: true, message: '请选择关联订单', trigger: 'change'}],
                payment_company_name: [{required: true, message: '请选择回款公司', trigger: 'change'}],
                payment_date: [{required: true, message: '请选择回款时间', trigger: 'change'}],
                payment_method: [{required: true, message: '请选择回款方式', trigger: 'change'}],
                repay_amount: [{required: true, message: '请输入回款金额', trigger: 'blur'}],
            },
            orderDetailsData: {
                total_price: '',
                contact_name: '',
                salesperson_name: '',
            },
            loading: false,
            selectOrderDialog: false,
            previewImgSrc: '',
            previewImgList: [],
            relateCustomList: [],
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: [Number, String],
            default: 0,
        },
        source: {
            type: String,
            default: 'list'
        },
        receivable_no: {
            type: String,
            default: ''
        },
        projectId: {
            type: Number,
            default: 0,
        }, //项目id
    },
    created() {
        if (this.order_id && this.source === 'detail') {
            this.getOrderDetail()
        }
        if (this.receivable_no) {
            this.getReceivableDetail()
        }
        this.repaymentForm.payment_date = getNowDate()
    },
    components: {RelateOrderSelect},
    mounted() {
    },
    methods: {
        //获取订单详情
        getOrderDetail() {
            this.loading = true
            orderDetail({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.orderDetailsData.total_price = res.data.total_price.value
                    this.orderDetailsData.salesperson_name = res.data.salesperson.text[0].name
                    this.repaymentForm.order_num = res.data.order_num
                    this.repaymentForm.salesperson = res.data.salesperson.value[0]
                    this.repaymentForm.payment_company_name = res.data.customer_id.text
                    this.orderDetailsData.contact_name = res.data.contact_id.text[0].name
                    this.getRelateCustomList()
                } else {

                    this.loading = false
                }
            })
        },

        // 详情
        getReceivableDetail() {
            this.loading = true;
            ReceivableDetail({receivable_no: this.receivable_no}).then((res) => {
                if (res.code === 200) {
                    this.repaymentForm.payment_company_name = res.data.basic_info.payment_company_name;
                    this.repaymentForm.payment_method = res.data.basic_info.payment_method;
                    this.repaymentForm.repay_amount = res.data.basic_info.payment_amount;
                    this.repaymentForm.remark = res.data.basic_info.remark;
                    this.repaymentForm.attachments = res.data.basic_info.attachments;
                    this.getOrderDetail()
                } else {
                    ;
                }
                this.loading = false;
            });
        },

        handleOrderSelectFocus() {
            this.selectOrderDialog = true
        },

        //点击切换关联客户
        handleInvoiceCompanySelect(item) {
            if (item.customer_contacts.length) {
                this.orderDetailsData.contact_name = item.customer_contacts[0].name
            }
        },

        //选择订单事件
        handleClickOrderRow(data) {
            this.repaymentForm.order_num = data.order_num
            this.repaymentForm.payment_company_name = data.customer_name
            this.orderDetailsData.total_price = data.total_price
            this.orderDetailsData.contact_name = data.contact_name
            this.orderDetailsData.salesperson_name = data.salesperson_name
            this.repaymentForm.salesperson = data.salesperson
            this.getRelateCustomList()
        },

        getRelateCustomList() {
            invoiceInfoByOrder({
                order_num: this.repaymentForm.order_num
            }).then(res => {
                if (res.code === 200) {
                    this.relateCustomList = res.data.customer_list
                } else {

                }
                this.loading = false
            })
        },

        //本次回款金额输入框失焦事件
        handleInvoiceAmountInputBlur() {
            let val = this.repaymentForm.repay_amount.replace(/[^\d.\-]/g, '');
            let amount = val ? Math.abs(parseFloat(val)) : 0;
            this.repaymentForm.repay_amount = amount.toFixed(2);
        },

        //上传文件
        handleUploadFileChange(e) {
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                if (file.size > 50 * 1024 * 1024) return that.$message.error('附件大小不能超过50m')
                uploadImg(file, file.size).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.repaymentForm.attachments.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
            this.$emit('update:receivable_no', '')
        },

        //确定事件
        handleClickConfirm() {
            this.$refs.repaymentForm.validate(valid => {
                if (valid) {
                    orderCreateRepay(this.repaymentForm).then(res => {
                        if (res.code === 200) {
                            this.$message.success('回款申请提交成功')
                            this.$emit('update:dialogVisible', false)
                            this.$emit('refresh')
                        } else {

                        }
                    })
                } else {
                    return false
                }
            })
        },
    },
}
</script>
<style lang="scss">
.repayment_dialog .el-dialog__body {
    padding: 24px;

    .el-select, .el-date-editor {
        width: 100%;
    }

    .custom_detail_form .el-form-item {
        margin-bottom: 16px;
    }
}
</style>